import * as React from 'react'
import { FormControl, Select, MenuItem } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'

import * as styles from './DropdownField.module.scss'

export const DropdownField = ({
  name,
  register,
  label,
  options = [],
  error,
  required,
  disabled,
  defaultValue = '',
  fieldStyle = {},
  hideLabel,
  backgroundColor,
  labelColor,
  placeholder,
  fullWidth = false,
}) => {
  return (
    <FormControl
      fullWidth={fullWidth}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(fullWidth ? {} : { maxWidth: '263px', margin: '0 auto' }),
      }}
    >
      {!hideLabel && (
        <InputLabel
          id={`${name}-label`}
          classes={{
            focused: !error ? styles.labelFocused : styles.labelFocusedError,
            asterisk: styles.asterisk,
          }}
          sx={{
            ...(labelColor && { color: labelColor }),
          }}
        >
          {label}
        </InputLabel>
      )}
      <Select
        labelId={`${name}-label`}
        id={name}
        label={hideLabel ? '' : label}
        defaultValue={defaultValue}
        {...register(name, { required })}
        classes={{
          focused: !error && styles.focusTest,
        }}
        sx={{
          ...fieldStyle,
          ...(fullWidth
            ? { width: '100%' }
            : { maxWidth: '263px', width: '263px' }),
          backgroundColor: '#4C3371',
          color: 'white !important',
          '& .MuiSelect-select': {
            color: 'white !important',
            fontWeight: 700,
          },
          '& .MuiInputBase-input': {
            color: 'white !important',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#4C3371',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#4C3371',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#4C3371',
          },
          '& .MuiSelect-icon': {
            color: 'white !important',
          },
          '&:hover': {
            backgroundColor: '#4C3371',
            '& .MuiSelect-select': {
              color: 'white !important',
            },
          },
          '&.Mui-focused': {
            backgroundColor: '#4C3371',
            '& .MuiSelect-select': {
              color: 'white !important',
            },
          },
          ...(backgroundColor && {
            backgroundColor: backgroundColor,
            '&:hover': {
              backgroundColor: backgroundColor,
            },
            '&.Mui-focused': {
              backgroundColor: backgroundColor,
            },
          }),
          ...(labelColor && {
            color: labelColor,
          }),
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: 'white',
              ...(fullWidth ? {} : { maxWidth: '263px' }),
              '& .MuiMenuItem-root': {
                fontSize: '1rem',
                padding: '0.75rem 1rem',
                borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                color: '#000',
                backgroundColor: 'white',
                '&:last-child': {
                  borderBottom: 'none',
                },
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  color: '#000',
                },
                '&.Mui-selected': {
                  backgroundColor: 'rgba(0, 0, 0, 0.08)',
                  color: '#000',
                  fontWeight: 500,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.12)',
                    color: '#000',
                  },
                },
                '&.Mui-disabled': {
                  color: 'rgba(0, 0, 0, 0.38)',
                  backgroundColor: 'white',
                },
              },
            },
          },
        }}
      >
        {placeholder && (
          <MenuItem value="placeholder" disabled className={styles.menuItem}>
            {placeholder}
          </MenuItem>
        )}
        {options.map(option => (
          <MenuItem
            key={option.value}
            value={option.value}
            className={styles.menuItem}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText error>{error.message}</FormHelperText>}
    </FormControl>
  )
}
